import ServiceItem from "./ServiceItem";
import "./Main.css";

const HowSection = () => {
  return (
    <div className="how-section">
      <div className="uigrid how-intro">
        <div className="uigrid-6 how-header">
          <h3>Build, run, and extend commerce software.</h3>
        </div>
        <div className="uigrid-5 how-text">
          <p>
            We develop products we operate in production, and take on selected
            partner work where teams need serious engineering in ordering,
            payments, and operations.
          </p>
        </div>
      </div>
      <div className="uigrid service-items">
        <ServiceItem
          title="Ordering & checkout"
          description="Consumer apps and web ordering for restaurants, cloud kitchens, and QSR brands."
          to="/platform#jazzys-burger"
          id="research"
        />
        <ServiceItem
          title="Payments & operations"
          description="Multi-gateway payments, inventory, branches, and admin for multi-location businesses."
          to="/platform"
          id="discussion"
        />
        <ServiceItem
          title="Merchant platforms"
          description="Storefronts, catalogues, and self-serve tooling for businesses selling online."
          to="/platform#awashop"
          id="ideation"
        />
        <ServiceItem
          title="Partner engineering"
          description="Selected projects for product companies that need a team to design, build, and ship."
          to="/services"
          id="implementation"
        />
      </div>
    </div>
  );
};

export default HowSection;
